//ui lists
import type { App, Component } from 'vue';


import blocks from './blocks/zzz';
import buttons from './buttons/zzz';
import charts from './charts/zzz';
import check from './check/zzz';
import core from './core/zzz';
import icons from './icons/zzz';
import input from './input/zzz';
import loaders from './loaders/zzz';
import menu from './menu/zzz';
import popup from './popup/zzz';
import selects from './select/zzz';
import switchs from './switch/zzz';
import tabs from './tabs/zzz';
import tags from './tags/zzz';
import title from './title/zzz';

const list = new Map<string, Component>();

blocks.forEach((v,k) => { list.set(k,v)});
core.forEach((v,k) => { list.set(k,v)});
check.forEach((v,k) => { list.set(k,v)});
buttons.forEach((v,k) => { list.set(k,v)});
title.forEach((v,k) => { list.set(k,v)});
input.forEach((v,k) => { list.set(k,v)});
popup.forEach((v,k) => { list.set(k,v)});
icons.forEach((v,k) => { list.set(k,v)});
tags.forEach((v,k) => { list.set(k,v)});
tabs.forEach((v,k) => { list.set(k,v)});
switchs.forEach((v,k) => { list.set(k,v)});
selects.forEach((v,k) => { list.set(k,v)});
menu.forEach((v,k) => { list.set(k,v)});
loaders.forEach((v,k) => { list.set(k,v)});
charts.forEach((v,k) => { list.set(k,v)});

export function install(app: App){
    list.forEach((v: Component, k: string) => app.component(k, v));
}

// main.ts
// import { install } from '../ui/index';
// install(app)